// ==========================================
// 1. EXPOSE FUNCTIONS GLOBALLY
// ==========================================

// Global function to initialize Quick Add Forms
window.initQuickAddForms = function() {
  console.log('initQuickAddForms');
  const quickAddForms = document.querySelectorAll('form.quick-add-to-cart-form:not([data-ajax-initialized])');

  quickAddForms.forEach(form => {
    // Mark as initialized to prevent double-binding
    form.setAttribute('data-ajax-initialized', 'true');

    form.addEventListener('submit', function(event) {
      event.preventDefault(); // Stop page redirect

      // Find the specific button inside this clicked form
      const submitButton = this.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('btn--loading'); // Keeps loading spinner spinning
      }

      // Package up the Variant ID and attributes
      const formData = new FormData(this);

      // Send background request to Shopify
      fetch(window.Shopify?.routes?.root + 'cart/add.js' || '/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) throw new Error('Network error');
        return response.json();
      })
      .then(cartData => {
        console.log('Successfully added product:', cartData);
        
        // Reset the button state
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('btn--loading');
        }

        // Trigger the theme's update events
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: cartData } }));
      })
      .catch(error => {
        console.error('Failed to add item:', error);
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('btn--loading');
        }
      });
    });
  });
};

// Global function to initialize Slider Wrappers
window.initSliders = function() {
  console.log('initSliders');
  const sliderWrappers = document.querySelectorAll('.slider-wrapper:not([data-slider-initialized])');

  sliderWrappers.forEach(sliderWrapper => {
    const slider = sliderWrapper.querySelector('.slider');
    const prevButton = sliderWrapper.querySelector('button[name="previous"]');
    const nextButton = sliderWrapper.querySelector('button[name="next"]');
    
    // Safety check in case elements are missing in HTML
    if (!slider || !prevButton || !nextButton) return;

    // Mark as initialized to prevent double-binding
    sliderWrapper.setAttribute('data-slider-initialized', 'true');
    
    // Next Button Click
    nextButton.addEventListener('click', () => {
      const firstItem = slider.querySelector('.grid__item');
      if (!firstItem) return;

      const itemWidth = firstItem.offsetWidth; 
      const containerWidth = slider.clientWidth; 
      const visibleItemsCount = Math.round(containerWidth / itemWidth);
      const scrollAmount = itemWidth * visibleItemsCount;

      if (slider.scrollLeft + containerWidth >= slider.scrollWidth - 5) {
        slider.scrollLeft = 0;
      } else {
        slider.scrollLeft += scrollAmount;
      }
    });

    // Previous Button Click
    prevButton.addEventListener('click', () => {
      const firstItem = slider.querySelector('.grid__item');
      if (!firstItem) return;

      const itemWidth = firstItem.offsetWidth;
      const containerWidth = slider.clientWidth;
      const visibleItemsCount = Math.round(containerWidth / itemWidth);
      const scrollAmount = itemWidth * visibleItemsCount;

      if (slider.scrollLeft <= 5) {
        slider.scrollLeft = slider.scrollWidth;
      } else {
        slider.scrollLeft -= scrollAmount;
      }
    });
  });
};


// ==========================================
// 2. AUTOMATIC INITIAL RUN ON PAGE LOAD
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
  window.initQuickAddForms();
  window.initSliders();
});
